import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Button, Form, Spinner } from "react-bootstrap";
import TableComponent from '../Table/Table';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import toast, { Toaster } from 'react-hot-toast';

function CreateMailingTemplate() {

    const navigate = useNavigate();

    const columns = React.useMemo(
        () => [
            {
                Header: 'ID',
                accessor: 'id', // accessor is the "key" in the data
            },
            {
                Header: 'Username',
                accessor: 'username', // accessor is the "key" in the data
            },
            {
                Header: 'Email',
                accessor: 'email',
            },
            {
                Header: 'Active',
                accessor: 'active',
            },

        ],
        []
    );
    const [userFilter, setUserFilter] = useState({
        username: ""
    })
    const [loading, setLoading] = useState(false);
    const [mloading, setMloading] = useState(false);
    
    const [language, setLanguage] = useState("");
    const [template, setTemplate] = useState("");
    const [languages, setLanguages] = useState([]);
    const [templates, setTemplates] = useState([]);

    const StoreUser = useSelector((state) => state.user);
    const [affliatePermission, setAffliatePermission] = useState(false)
    const checkPermission = (user, permission) => {
        var Permissions = user.Permissions;
        if (Permissions && Permissions.length > 0) {
            const index = Permissions.findIndex(per => per === permission)
            if (index != -1) return true;
            else return false;
        }
        return true
    }

    const GetLanguages = async () => {
        const response = await axios.get(window.__CFG.API + "manager/ListAllLanguages", {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("raff-token")
            }
        })

        if (response.data.Error == null) {
            setLanguages(response.data.Result)
        }
    }
    const GetTemplates = async () => {
        const response = await axios.get(window.__CFG.API + "manager/ListAllStaticTemplates", {
            headers : {
                "Authorization" : "Bearer "+localStorage.getItem("raff-token")
            }
        })

        if(response.data.Error == null) {
            setTemplates(response.data.Result);
        }
    }

    useEffect(() => {
        GetLanguages();
        GetTemplates();
    }, []);

    const CreateTemplate = async () => {
        setMloading(true);
        const response = await axios.post(window.__CFG.API + "manager/CreateMailingTemplate", {
            template : template,
            language : language
        }, {
            headers : {
                "Authorization" : "Bearer "+localStorage.getItem("raff-token")
            }
        })
        setMloading(false);

        if(response.data.Error == null) {
            navigate("/affiliate/settings/mailing-templates");
            toast.success(response.data.Error, {
                duration: 4000
            });
        } else {
            toast.error(response.data.Error, {
                duration: 4000
            });
        }
    }

    return (
        <Container>
            <Row >
                <div className='aff-grp-section'>
                    <div className='aff-grp-section-title'>
                        Create Mailing Template
                    </div>

                    <div className="promo-form-wp">
                        <div className="promo-form">
                            <div className="promo-lbl">
                                Language
                            </div>
                            <div className="promo-in">
                                <select onChange={e => setLanguage(e.target.value)} style={{ padding: 5, width: "100%" }} >
                                    <option value="">Language</option>
                                    {
                                        languages.filter(d => {
                                            return d.value != ""
                                        }).map(language => {
                                            return (
                                                <option value={language.value}>{language.label}</option>
                                            )
                                        })
                                    }
                                </select>
                            </div>
                        </div>
                        <div className="promo-form">
                            <div className="promo-lbl">
                                Template
                            </div>
                            <div className="promo-in">
                                <select onChange={e => setTemplate(e.target.value)} style={{ padding: 5, width: "100%" }} >
                                    <option value="">Template</option>
                                    {
                                        templates.filter(d => {
                                            return d.value != ""
                                        }).map(template => {
                                            return (
                                                <option value={template.value}>{template.label}</option>
                                            )
                                        })
                                    }
                                </select>
                            </div>
                        </div>
                        <div className="promo-form">
                            <div className="promo-lbl">
                            </div>
                            <div className="promo-in">
                                <Button onClick={CreateTemplate} disabled={mloading} className="w-100 bg-warning border-0 rounded-0 btn-height text-black btn-com-grp "
                                >
                                    {
                                        mloading ? (
                                            <>
                                                <Spinner size="sm" />
                                            </>
                                        ) : (
                                            <>Create Mailing Template</>
                                        )
                                    }
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </Row>


        </Container>
    )
}

export default CreateMailingTemplate